import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../routes/Module13";
import LayoutActividad from "../../components/LayoutActividad";
import Sidebar from "./Sidebar";
import Imagen from "../../images/modulo13/dondevivimos.png";
import GuiaDocente from "../../components/GuiaDocente";
import AudioPlayer from "../../audioPlayer/AudioPlayer";
import Audio from "../../audios/modulo13/Inicio.mp3";

const Modulo1 = () => {
  const nextUnity = modulo13.content[0];
  const nextActivity = nextUnity.activities[0];

  const pages = {
    titleNext: `${nextActivity.name}`,
    linkNext: `${modulo13.url}/${nextUnity.path}/${nextActivity.path}`,
  };
  const crumbs = [
    {
      title: `${modulo13.title} > Inicio `,
      url: "/" + modulo13.url,
    },
  ];
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title}`,
    name: modulo13.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div>
        <h1 className="my-5">{modulo13.title}</h1>
        <AudioPlayer track={Audio} />
      </div>

      <div className="">
        <img src={Imagen} className="img-fluid" alt="..." />
      </div>
      <div className="mt-4">
        <p>
          En este módulo conoceremos la diversidad de nuestro territorio.
          Conoceremos cómo nos adaptamos a él y lo transformamos, cuáles son los
          recursos naturales que posee y cómo es la vida en las ciudades
          actuales. También pensaremos en la importancia de convivir, deliberar
          y participar para vivir en el territorio que todos queremos.
        </p>
        <ul>
          <li>
            Identificamos la diversidad del territorio que compone el Perú.
          </li>
          <li>
            Conocemos procesos históricos que explican la adaptación y
            transformación de dicho territorio.
          </li>
          <li>
            Compartimos nuestras experiencias personales a partir de lo
            aprendido.
          </li>
          <li>
            Reflexionamos sobre la diversidad de nuestro territorio y nos
            reconocemos como parte de ella.
          </li>
        </ul>
      </div>
      <div className="unit-options my-5">
        <a href={"https://ciudadania.pe/actividades-interactivas/" + pages.linkNext}>
          <button className={`btn btn-${modulo13.color} me-2`}>
            Empezar actividades <FontAwesomeIcon icon={faMap} />
          </button>
        </a>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que, en silencio, lean la pregunta y que
            observen la ilustración. Pregunte y recoja las
            respuestas:
            <ul>
              <li>
                <i>
                  “A partir de lo observado, ¿de qué creen que tratará este
                  módulo de contenido?”. Resalte que se pregunta por el lugar
                  donde viven los peruanos, es decir, su territorio. En la
                  ilustración se muestra el mapa del Perú. En este se puede
                  observar algunos elementos que son parte de su geografía (mar,
                  los Andes, la selva) y los diferentes recursos que nos ofrece
                  el territorio (peces, petróleo, frutos, vegetales, tubérculos,
                  minerales, madera, etc.)”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Ahora, lea el texto que explica de qué tratará esta unidad y lo que
            se busca con las actividades a realizar.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Modulo1;
